module.exports = __webpack_public_path__ + "static/media/galleryGT (1).75c82f57.jpg";